import type { GameState, UpdateSeatOrderAction } from "../types";
import { reorderPlayerStates } from "../utils/seat-order";

export function applyUpdateSeatOrder(
  state: GameState,
  action: UpdateSeatOrderAction,
): GameState {
  return {
    ...state,
    version: state.version + 1,
    seatOrder: [...action.seatOrder],
    players: reorderPlayerStates(state.players, action.seatOrder),
  };
}
